<template>
  <DebounceUpdate :debounce-time="100" @update="emitUpdate" v-slot="{ debounced }">
    <div class="quick-search__input">
      <InputBox
        ref="input"
        clear-button
        :placeholder="$t('action.search')"
        :model-value="query"
        @update:model-value="debounced"
        focus-shortcut="search"
        test-id="top-bar-quick-search"
      >
        <template #icon>
          <SearchIcon16 />
        </template>
      </InputBox>
    </div>
  </DebounceUpdate>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SearchIcon16 from '@components/Icons/SearchIcon16.vue';

export default defineComponent({
  name: 'TopBarQuickSearch',

  components: {
    SearchIcon16,
  },

  emits: { update: null },

  data() {
    return {
      query: '',
    };
  },

  methods: {
    emitUpdate(value: string) {
      this.query = value;
      this.$emit('update', this.query);
    },
  },
});
</script>

<style lang="scss">
.quick-search__input {
  width: 150px;
}
</style>
